import React from 'react';
import Header from '../components/Header/header.js';
import Footer from '../components/Footer/footer.js';
import Team from '../components/Team/team.js';

function AboutUs() {
  return (
    <>
      <Header />
      <main>
        <Team />
      </main>
      <Footer />
    </>
  );
}

export default AboutUs;
